export default __webpack_public_path__ + "af8077060e98afb4028f23ccfbace41d.png";